export default __webpack_public_path__ + "static/media/elodie.09d37ec0.png";